import React from 'react'
import styled from 'styled-components'
import { Row, Col, Layout } from 'antd'
import { PrimaryButton } from 'Components/Shared/Button'
import DefectScore from 'Components/Defect/DefectScore'

import { DefectItem } from 'features/report/constructPlan/types'
import { DefectStatus } from 'features/types/status'
import { NcrPrefix } from 'Components/Shared'

const { Footer } = Layout

type Props = {
  onDelete: () => void
  onSave: () => void
  defect: DefectItem
  addMode?: boolean
}

const DefectFooter: React.FC<Props> = ({
  onDelete,
  onSave,
  defect,
  addMode = true,
}) => {
  let ncrEmpty = false
  let detailEmpty = false
  if (defect.PinStatus === DefectStatus.TOBEFIX) {
    ncrEmpty = defect.DefectTypeID <= 0
    detailEmpty = defect.DetailID <= 0
  }

  const subjobEmpty = defect.SubJobTypeID <= 0
  const unitEmpty = defect.UnitList.length === 0

  const imgEmpty =
    defect.ImageLocation === undefined || defect.ImageBefore === undefined

  const disableSave =
    ncrEmpty || subjobEmpty || detailEmpty || imgEmpty || unitEmpty

  return (
    <Footer className="detail-page-footer">
      <FooterContent>
        <Row type="flex" justify="space-between" align="middle">
          <Col>
            {addMode && (
              <Button>
                <PrimaryButton text="ลบ" onClick={onDelete} btnType="Cancel" />
              </Button>
            )}
          </Col>
          <Col>
            <Row type="flex" align="middle">
              <Col>
                <ScoreArea>
                  <Score>
                    <DefectScore
                      prefix={<NcrPrefix defect={defect} />}
                      suffix={<Desc>คะแนน</Desc>}
                      pinStatus={defect.PinStatus}
                      pinScore={defect.Score}
                    />
                  </Score>
                </ScoreArea>
              </Col>
              <Col>
                <Button>
                  <PrimaryButton
                    text="บันทึก"
                    disabled={disableSave}
                    onClick={onSave}
                  />
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
      </FooterContent>
    </Footer>
  )
}

const FooterContent = styled.div`
  max-width: 1110px;
  margin: 0 auto;
  color: #000;
  font-size: 20px;
  padding-right: 20px;
`

const Button = styled.div`
  width: 160px;
`

const Desc = styled.span`
  font-family: 'DB Helvethaica X 55 Regular';
  font-size: 18px;
  margin-left: 16px;
`

const ScoreArea = styled.div`
  margin-right: 32px;
`

const Score = styled.span`
  font-size: 44px;
`

export default DefectFooter
